(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mbl-section-slideshow"] && !Shopify.designMode) return;
  try {
      
const selectedSlide = document.querySelectorAll('.slideshow__slide');
selectedSlide[0].classList.add('is-selected');

function handleSlideChange() {
  selectedSlide.forEach(function(slide) {
    if (!slide.classList.contains('is-selected')) {
      slide.style.zIndex = '1';
    } else {
      slide.style.zIndex = '999';
    }
  });

  // Add your code to execute when the slide changes here
  console.log('Slide changed!');
}

selectedSlide.forEach(function(slide) {
  slide.addEventListener('click', handleSlideChange);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbl-section-what-inside"] && !Shopify.designMode) return;
  try {
    

    var carouselMbl = document.querySelector('.inside-ingredients .carousel');
    var flkty = new Flickity( carouselMbl, {
        pageDots: false,
        groupCells: getGroupCellsOption(),
        wrapAround: true
    });
    function getGroupCellsOption() {
        return window.innerWidth < 768 ? 1 : 2;
    }
    var slideIndexMapping = {
  0: 0,
  1: 1,
  2: 2,
  3: 3
};


   

window.addEventListener('resize', function() {
  flkty.options.groupCells = getGroupCellsOption();
  flkty.destroy();
  flkty = new Flickity('.inside-ingredients .carousel', flkty.options);
});


    var buttonGroup = document.querySelector('.inside-ingredients .button-group');
    var buttons = buttonGroup.querySelectorAll('.button');
    buttons = fizzyUIUtils.makeArray( buttons );
    buttonGroup.addEventListener( 'click', function( event ) {
    if ( !matchesSelector( event.target, '.button' ) ) {
        return;
     }
      // Get the slide index from the data-slide-index attribute
  var slideIndex = parseInt(event.target.getAttribute('data-slide-index'), 10);
  var screenWidth = window.innerWidth || document.documentElement.clientWidth;
  if (screenWidth < 768) {
    buttons[0].classList.add('is-selected');
    slideIndex += slideIndexMapping[slideIndex] || 0;
}
// Select the slide based on the slide index
flkty.select(slideIndex);
flkty.on('select', function() {
    var previousSelectedButton = buttonGroup.querySelector('.is-selected');
    var selectedButton;
    if (screenWidth < 768) {
      selectedButton = buttonGroup.children[slideIndex + (slideIndexMapping[slideIndex] || 0)];
    } else {
      selectedButton = buttonGroup.children[flkty.selectedIndex];
    }

    previousSelectedButton.classList.remove('is-selected');
    selectedButton.classList.add('is-selected');
  });
});



  } catch(e) { console.error(e); }
})();
})();
